// Trello-style placeholder shown while a board loads (initial open or switch),
// so the user sees the board's shape immediately instead of a blank page.
// Stable ids are generated once at module load to avoid array-index keys.
let uid = 0;
const SKELETON_COLUMNS = [3, 2, 4, 2].map((count) => {
  uid += 1;
  const colId = `sk-col-${uid}`;
  const cards = Array.from({ length: count }).map(() => {
    uid += 1;
    return `sk-card-${uid}`;
  });
  return { id: colId, cards };
});

export default function BoardSkeleton() {
  return (
    <div
      className="flex min-h-0 flex-1 items-start gap-3 overflow-hidden px-4 pb-4 pt-3"
      aria-busy="true"
      aria-label="Loading board"
    >
      {SKELETON_COLUMNS.map((col) => (
        <div
          key={col.id}
          className="flex w-72 shrink-0 flex-col rounded-xl bg-[var(--p-color-bg-surface-secondary)] shadow-sm"
        >
          <div className="flex items-center gap-2 px-3 py-2.5">
            <div className="h-4 w-24 animate-pulse rounded bg-[var(--p-color-bg-surface-tertiary)]" />
            <div className="ml-auto h-4 w-6 animate-pulse rounded bg-[var(--p-color-bg-surface-tertiary)]" />
          </div>
          <div className="space-y-2 px-2 pb-3">
            {col.cards.map((cardId) => (
              <div
                key={cardId}
                className="rounded-lg border border-[var(--p-color-border)] bg-[var(--p-color-bg-surface)] p-3 shadow-sm"
              >
                <div className="mb-2 h-3 w-3/4 animate-pulse rounded bg-[var(--p-color-bg-surface-tertiary)]" />
                <div className="h-3 w-1/2 animate-pulse rounded bg-[var(--p-color-bg-surface-tertiary)]" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
